import { CycleUtils } from '@wix/package-picker-shared';
// TODO: Write tests
export const parseProductDetails = data => {
  return {
    ...data,
    paymentCycle: CycleUtils.convertPaymentCycle(data == null ? void 0 : data.paymentCycle)
  };
};
export const parseDowngradeDetails = data => {
  const currentPlanDetails = parseProductDetails(data.currentPlanDetails);
  const destinationProductDetails = parseProductDetails(data.destinationProductDetails);
  return {
    ...data,
    currentPlanDetails,
    destinationProductDetails,
    downgradeType: data.changePlanType
  };
};
//# sourceMappingURL=downgradeDetailsParsers.js.map